import React from "react";

interface ExportButtonProps {
  onExport: () => void;
  onPrint?: () => void;
  loading?: boolean;
}

export default function ExportButton({ onExport, onPrint, loading }: ExportButtonProps) {
  return (
    <div className="flex gap-2 no-print">
      <button
        onClick={onExport}
        disabled={loading}
        className="btn-secondary"
        title="تصدير CSV"
      >
        تصدير CSV
      </button>
      <button
        onClick={onPrint ?? (() => window.print())}
        className="btn-secondary"
        title="طباعة"
      >
        طباعة
      </button>
    </div>
  );
}
